function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Button, ButtonGroup, HStack, IconButton, useDisclosure } from '@chakra-ui/react';
import Heading from '@/components/Heading';
import { addRegular, deleteRegular, getRegulars } from '@/actions/RegularUserActions';
import Table from '@/components/Table';
import { AuthProviders } from '@/types/server';
import { faPeopleGroup, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import dayjs from '@/utils/dayjs';
import InputModal from '@/components/InputModal';
import useChannelStore from '@/stores/ChannelStore';
import TableHeading from '@/components/TableHeading';
import useQueryState from '@/hooks/useQueryState';
import { useLimitQueryState, usePageQueryState, useSearchQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import { SortDirections } from '@/types/client';
import { useDebounce } from 'use-debounce';
import SearchInput from '@/components/SearchInput';
import EmptyState from '@/components/EmptyState';
import DashboardLayout from '../layouts/DashboardLayout';
import { FormattedMessage, useIntl } from 'react-intl';
import Pagination from '../Pagination';
import useIntlMemo from '@/hooks/useIntlMemo';
import { Helmet } from 'react-helmet';
import styles from './Regulars.module.scss';
import { ActionIcon, Table as MantineTable } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["CREATED_AT"] = "createdAt";
    HeadingKeys["USER"] = "displayName";
})(HeadingKeys || (HeadingKeys = {}));
function RegularUserHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, sortDirection) {
        setSortDirection(sortDirection);
        setSortBy(sortDirection != null ? key : null);
    }
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                className: styles.createdAtHeader,
                active: sortBy === "createdAt",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("createdAt", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wittYy",
                    defaultMessage: "Created At"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                className: styles.userHeader,
                active: sortBy === "displayName",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("displayName", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "EwRIOm",
                    defaultMessage: "User"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                alignRight: true,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wL7VAE",
                    defaultMessage: "Actions"
                })
            })
        ]
    });
}
function RegularUserRow(param) {
    var user = param.user, onDelete = param.onDelete;
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.createdAtColumn,
                children: dayjs(user.createdAt).format('MMM D, YYYY')
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.userColumn,
                children: user.displayName
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.actionsColumn,
                children: /*#__PURE__*/ _jsx(ActionIcon, {
                    size: "sm",
                    "aria-label": intl.formatMessage({
                        id: "CWUp+a",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Delete Regular"
                            }
                        ]
                    }),
                    onClick: onDelete,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        size: IconSizes.SM,
                        icon: faTrash
                    })
                })
            })
        ]
    });
}
export default function Regulars() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), regulars = _React_useState[0], setRegulars = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), selectedRegularId = _React_useState1[0], setSelectedRegularId = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(0), 2), totalRegulars = _React_useState2[0], setTotalRegulars = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), isSearching = _React_useState3[0], setIsSearching = _React_useState3[1];
    var deleteRegularModal = useDisclosure();
    var addRegularModal = useDisclosure();
    var _useSearchQueryState = _sliced_to_array(useSearchQueryState(), 2), search = _useSearchQueryState[0], setSearch = _useSearchQueryState[1];
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "displayName"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var loadRegulars = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(page, limit, query, sortBy, sortDirection) {
            var _ref, newRegulars, total, currentChannel;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getRegulars(channel._id, {
                                limit: limit,
                                offset: page * limit,
                                query: query != null && query.length > 0 ? query : undefined,
                                sortBy: sortBy !== null && sortBy !== void 0 ? sortBy : undefined,
                                direction: sortDirection !== null && sortDirection !== void 0 ? sortDirection : undefined
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), newRegulars = _ref.regulars, total = _ref.total;
                        currentChannel = useChannelStore.getState().channel;
                        if (currentChannel == null || currentChannel._id !== channel._id) {
                            return [
                                2
                            ];
                        }
                        setTotalRegulars(total);
                        setRegulars(newRegulars);
                        setIsSearching(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(page, limit, query, sortBy, sortDirection) {
            return _ref.apply(this, arguments);
        };
    }(), [
        channel
    ]);
    // handle initial load, channel changes, search changes
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        if (page !== 0) {
            setPage(0);
            return;
        }
        loadRegulars(page, limit, debouncedSearch, sortBy, sortDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel,
        loadRegulars,
        debouncedSearch
    ]);
    // handle pagination/sorting changes
    React.useEffect(function() {
        if (channel == null || regulars == null) {
            return;
        }
        loadRegulars(page, limit, debouncedSearch, sortBy, sortDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page,
        limit,
        sortBy,
        sortDirection
    ]);
    // set searching state when search changes, not when we start loading results
    React.useEffect(function() {
        if (search.length === 0) {
            return;
        }
        setIsSearching(true);
    }, [
        search
    ]);
    function handleDeleteRegular() {
        return _handleDeleteRegular.apply(this, arguments);
    }
    function _handleDeleteRegular() {
        _handleDeleteRegular = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selectedRegularId == null || channel == null || regulars == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            deleteRegular(channel._id, selectedRegularId)
                        ];
                    case 1:
                        _state.sent();
                        loadRegulars(page, limit, debouncedSearch, sortBy, sortDirection);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleDeleteRegular.apply(this, arguments);
    }
    function handleAddRegular(username) {
        return _handleAddRegular.apply(this, arguments);
    }
    function _handleAddRegular() {
        _handleAddRegular = _async_to_generator(function(username) {
            var lastPage, sortedRegulars, index, newPage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null || regulars == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            addRegular(channel._id, username)
                        ];
                    case 1:
                        _state.sent();
                        // a lot of logic just to make sure the user sees the regular they just added
                        if (sortBy === "createdAt" && sortDirection === SortDirections.ASC) {
                            lastPage = Math.ceil((totalRegulars + 1) / limit) - 1;
                            if (page !== lastPage) {
                                setPage(lastPage);
                                return [
                                    2
                                ];
                            }
                        } else if (sortBy === "createdAt" && sortDirection === SortDirections.DESC) {
                            if (page !== 0) {
                                setPage(0);
                                return [
                                    2
                                ];
                            }
                        } else if (sortBy === "displayName") {
                            sortedRegulars = _to_consumable_array(regulars);
                            sortedRegulars.push({
                                displayName: username,
                                createdAt: '',
                                _id: '',
                                name: '',
                                provider: AuthProviders.TWITCH,
                                providerId: '',
                                updatedAt: ''
                            });
                            if (sortDirection === SortDirections.DESC) {
                                sortedRegulars.sort(function(a, b) {
                                    return b.displayName.localeCompare(a.displayName);
                                });
                            } else {
                                sortedRegulars.sort(function(a, b) {
                                    return a.displayName.localeCompare(b.displayName);
                                });
                            }
                            index = sortedRegulars.findIndex(function(user) {
                                return user.displayName === username;
                            });
                            newPage = Math.floor(index / limit);
                            if (page !== newPage) {
                                setPage(newPage);
                                return [
                                    2
                                ];
                            }
                        }
                        loadRegulars(page, limit, debouncedSearch, sortBy, sortDirection);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleAddRegular.apply(this, arguments);
    }
    var addRegularDescriptionPrompt = useIntlMemo(function(intl) {
        if ((channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE) {
            return intl.formatMessage({
                id: "Q+6vVH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Enter the @Handle or Channel URL of the user you want as regular."
                    }
                ]
            });
        } else {
            return intl.formatMessage({
                id: "CSwwP/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Enter the username of the user you want as regular."
                    }
                ]
            });
        }
    }, [
        channel,
        intl
    ]);
    var addRegularInputPlaceholder = useIntlMemo(function(intl) {
        if ((channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE) {
            return intl.formatMessage({
                id: "DYwI6U",
                defaultMessage: [
                    {
                        type: 0,
                        value: "@Handle"
                    }
                ]
            });
        } else {
            return intl.formatMessage({
                id: "JCIgkj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Username"
                    }
                ]
            });
        }
    }, [
        channel,
        intl
    ]);
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "o458GP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Regulars"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "zFC8Dg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Regulars are users that can be granted extra privileges."
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "o458GP",
                    defaultMessage: "Regulars"
                })
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                children: [
                    /*#__PURE__*/ _jsx(SearchInput, {
                        search: search,
                        setSearch: setSearch,
                        placeholder: intl.formatMessage({
                            id: "OaLnjr",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search regulars"
                                }
                            ]
                        }),
                        isSearching: isSearching
                    }),
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        size: "sm",
                        ml: "auto",
                        variant: "cta",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: addRegularModal.onOpen,
                                display: {
                                    base: 'none',
                                    sm: 'block'
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Fhi4U4",
                                    defaultMessage: "New Regular"
                                })
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                display: {
                                    base: 'block',
                                    sm: 'none'
                                },
                                onClick: addRegularModal.onOpen,
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    icon: faPlus
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "2xN+AO",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "New Command"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: regulars,
                extraData: [
                    addRegularModal.onOpen,
                    deleteRegularModal.onOpen,
                    sortBy,
                    sortDirection,
                    limit,
                    page
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsx(RegularUserHeader, {
                        sortDirection: sortDirection,
                        sortBy: sortBy,
                        setSortDirection: setSortDirection,
                        setSortBy: setSortBy
                    });
                },
                renderRow: function(user) {
                    var onDelete = function onDelete() {
                        setSelectedRegularId(user._id);
                        deleteRegularModal.onOpen();
                    };
                    return /*#__PURE__*/ _jsx(RegularUserRow, {
                        user: user,
                        onDelete: onDelete
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(EmptyState, {
                        title: intl.formatMessage({
                            id: "FDsffa",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No Regulars"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "3Nn/4K",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Regulars are users that can be granted extra privileges, start by adding a new regular."
                                }
                            ]
                        }),
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.LG,
                            icon: faPeopleGroup
                        }),
                        buttons: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "cta",
                                onClick: addRegularModal.onOpen,
                                children: intl.formatMessage({
                                    id: "Fhi4U4",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "New Regular"
                                        }
                                    ]
                                })
                            }, "new-regular")
                        ]
                    });
                },
                renderFooter: function() {
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: limit,
                        page: page,
                        total: totalRegulars,
                        setLimit: setLimit,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "CWUp+a",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Regular"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "Zh5CoO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this regular?"
                        }
                    ]
                }),
                isOpen: deleteRegularModal.isOpen,
                onClose: deleteRegularModal.onClose,
                submitText: intl.formatMessage({
                    id: "CWUp+a",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Regular"
                        }
                    ]
                }),
                onSubmit: handleDeleteRegular
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "pzLThw",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Regular"
                        }
                    ]
                }),
                description: addRegularDescriptionPrompt,
                isOpen: addRegularModal.isOpen,
                onClose: addRegularModal.onClose,
                submitText: intl.formatMessage({
                    id: "pzLThw",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add Regular"
                        }
                    ]
                }),
                input: {
                    placeholder: addRegularInputPlaceholder
                },
                onSubmit: handleAddRegular
            })
        ]
    });
}
